function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m25 13c0-6.6167-5.3828-12-12-12s-12 5.3833-12 12c0 3.3836 1.4132 6.4387 3.6736 8.6223 0.052918 0.068909 0.1156 0.12476 0.18896 0.17181 2.1412 1.9828 4.9957 3.2059 8.1374 3.2059s5.9962-1.2231 8.1374-3.2059c0.073364-0.047058 0.13605-0.10291 0.18896-0.17181 2.2604-2.1836 3.6736-5.2386 3.6736-8.6223zm-12-10.5c5.79 0 10.5 4.7104 10.5 10.5 0 2.455-0.85327 4.7108-2.2703 6.5009-0.65051-2.0978-2.5076-3.7401-5.0281-4.4958 1.3736-0.99408 2.272-2.6046 2.272-4.4245 0-3.0142-2.4551-5.4663-5.4736-5.4663s-5.4736 2.4521-5.4736 5.4663c0 1.8199 0.89844 3.4304 2.272 4.4245-2.5205 0.75568-4.3776 2.3979-5.0281 4.4958-1.417-1.79-2.2703-4.0459-2.2703-6.5009 0-5.7896 4.71-10.5 10.5-10.5zm-3.9736 8.0806c0-2.187 1.7822-3.9663 3.9736-3.9663s3.9736 1.7793 3.9736 3.9663-1.7822 3.9663-3.9736 3.9663-3.9736-1.7793-3.9736-3.9663zm-2.9956 10.251c0.22546-2.7499 3.1416-4.7851 6.9692-4.7851s6.7438 2.0352 6.9692 4.7851c-1.8561 1.6536-4.2935 2.668-6.9692 2.668s-5.1131-1.0145-6.9692-2.668z"
});

var SvgAccount = function SvgAccount(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    enableBackground: "new 0 0 26 26",
    viewBox: "0 0 26 26",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account.1a94f899.svg";
export { ForwardRef as ReactComponent };